export const COUNTRIES = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
];

export const COUNTRY_CODES = ["US", "CA"] as const;

// us states array
export const US_STATES = [
  { value: "US-AL", label: "Alabama" },
  { value: "US-AK", label: "Alaska" },
  { value: "US-AZ", label: "Arizona" },
  { value: "US-AR", label: "Arkansas" },
  { value: "US-CA", label: "California" },
  { value: "US-CO", label: "Colorado" },
  { value: "US-CT", label: "Connecticut" },
  { value: "US-DE", label: "Delaware" },
  { value: "US-FL", label: "Florida" },
  { value: "US-GA", label: "Georgia" },
  { value: "US-HI", label: "Hawaii" },
  { value: "US-ID", label: "Idaho" },
  { value: "US-IL", label: "Illinois" },
  { value: "US-IN", label: "Indiana" },
  { value: "US-IA", label: "Iowa" },
  { value: "US-KS", label: "Kansas" },
  { value: "US-KY", label: "Kentucky" },
  { value: "US-LA", label: "Louisiana" },
  { value: "US-ME", label: "Maine" },
  { value: "US-MD", label: "Maryland" },
  { value: "US-MA", label: "Massachusetts" },
  { value: "US-MI", label: "Michigan" },
  { value: "US-MN", label: "Minnesota" },
  { value: "US-MS", label: "Mississippi" },
  { value: "US-MO", label: "Missouri" },
  { value: "US-MT", label: "Montana" },
  { value: "US-NE", label: "Nebraska" },
  { value: "US-NV", label: "Nevada" },
  { value: "US-NH", label: "New Hampshire" },
  { value: "US-NJ", label: "New Jersey" },
  { value: "US-NM", label: "New Mexico" },
  { value: "US-NY", label: "New York" },
  { value: "US-NC", label: "North Carolina" },
  { value: "US-ND", label: "North Dakota" },
  { value: "US-OH", label: "Ohio" },
  { value: "US-OK", label: "Oklahoma" },
  { value: "US-OR", label: "Oregon" },
  { value: "US-PA", label: "Pennsylvania" },
  { value: "US-RI", label: "Rhode Island" },
  { value: "US-SC", label: "South Carolina" },
  { value: "US-SD", label: "South Dakota" },
  { value: "US-TN", label: "Tennessee" },
  { value: "US-TX", label: "Texas" },
  { value: "US-UT", label: "Utah" },
  { value: "US-VT", label: "Vermont" },
  { value: "US-VA", label: "Virginia" },
  { value: "US-WA", label: "Washington" },
  { value: "US-WV", label: "West Virginia" },
  { value: "US-WI", label: "Wisconsin" },
  { value: "US-WY", label: "Wyoming" },
  { value: "US-DC", label: "District of Columbia" },
  { value: "US-AS", label: "American Samoa" },
  { value: "US-GU", label: "Guam" },
  { value: "US-MP", label: "Northern Mariana Islands" },
  { value: "US-PR", label: "Puerto Rico" },
  { value: "US-VI", label: "Virgin Islands" },
  { value: "US-UM", label: "United States Minor Outlying Islands" },
  { value: "US-AE", label: "Armed Forces Europe" },
  { value: "US-AA", label: "Armed Forces Americas" },
  { value: "US-AP", label: "Armed Forces Pacific" },
];

export const CA_PROVINCES = [
  { value: "CA-AB", label: "Alberta" },
  { value: "CA-BC", label: "British Columbia" },
  { value: "CA-MB", label: "Manitoba" },
  { value: "CA-NB", label: "New Brunswick" },
  { value: "CA-NL", label: "Newfoundland and Labrador" },
  { value: "CA-NS", label: "Nova Scotia" },
  { value: "CA-NT", label: "Northwest Territories" },
  { value: "CA-NU", label: "Nunavut" },
  { value: "CA-ON", label: "Ontario" },
  { value: "CA-PE", label: "Prince Edward Island" },
  { value: "CA-QC", label: "Quebec" },
  { value: "CA-SK", label: "Saskatchewan" },
  { value: "CA-YT", label: "Yukon" },
];

export const TX_REGION_LIST = [
  { value: "TX-REGION-01", label: "Region 1" },
  { value: "TX-REGION-02", label: "Region 2" },
  { value: "TX-REGION-03", label: "Region 3" },
  { value: "TX-REGION-04", label: "Region 4" },
  { value: "TX-REGION-05", label: "Region 5" },
  { value: "TX-REGION-06", label: "Region 6" },
  { value: "TX-REGION-07", label: "Region 7" },
  { value: "TX-REGION-08", label: "Region 8" },
  { value: "TX-REGION-09", label: "Region 9" },
  { value: "TX-REGION-10", label: "Region 10" },
  { value: "TX-REGION-11", label: "Region 11" },
  { value: "TX-REGION-12", label: "Region 12" },
  { value: "TX-REGION-13", label: "Region 13" },
  { value: "TX-REGION-14", label: "Region 14" },
  { value: "TX-REGION-15", label: "Region 15" },
  { value: "TX-REGION-16", label: "Region 16" },
  { value: "TX-REGION-17", label: "Region 17" },
  { value: "TX-REGION-18", label: "Region 18" },
  { value: "TX-REGION-19", label: "Region 19" },
  { value: "TX-REGION-20", label: "Region 20" },
];

export const US_REGIONS: Record<
  string,
  Array<{ value: string; label: string }>
> = {
  "US-TX": TX_REGION_LIST,
};

export const US_STATES_PLAIN = [
  "US-AL",
  "US-AK",
  "US-AZ",
  "US-AR",
  "US-CA",
  "US-CO",
  "US-CT",
  "US-DE",
  "US-FL",
  "US-GA",
  "US-HI",
  "US-ID",
  "US-IL",
  "US-IN",
  "US-IA",
  "US-KS",
  "US-KY",
  "US-LA",
  "US-ME",
  "US-MD",
  "US-MA",
  "US-MI",
  "US-MN",
  "US-MS",
  "US-MO",
  "US-MT",
  "US-NE",
  "US-NV",
  "US-NH",
  "US-NJ",
  "US-NM",
  "US-NY",
  "US-NC",
  "US-ND",
  "US-OH",
  "US-OK",
  "US-OR",
  "US-PA",
  "US-RI",
  "US-SC",
  "US-SD",
  "US-TN",
  "US-TX",
  "US-UT",
  "US-VT",
  "US-VA",
  "US-WA",
  "US-WV",
  "US-WI",
  "US-WY",
  "US-DC",
  "US-AS",
  "US-GU",
  "US-MP",
  "US-PR",
  "US-VI",
  "US-UM",
  "US-AE",
  "US-AA",
  "US-AP",
] as const;

export const CA_PROVINCES_PLAIN = [
  "CA-AB",
  "CA-BC",
  "CA-MB",
  "CA-NB",
  "CA-NL",
  "CA-NS",
  "CA-NT",
  "CA-NU",
  "CA-ON",
  "CA-PE",
  "CA-QC",
  "CA-SK",
  "CA-YT",
] as const;

export const STATE_PROVINCE_CODES = [
  ...US_STATES_PLAIN,
  ...CA_PROVINCES_PLAIN,
] as const;
